import React, { useState } from 'react';
import { db } from '../../firebase'; // Firebase config
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        createdAt: serverTimestamp()
      });
      alert("Message sent!");
      setFormData({ name: '', mobile: '', message: '' });
    } catch (err) {
      alert("Error saving data: " + err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input className='me-2 mt-2' name="name" onChange={handleChange} value={formData.name} placeholder="Name" required />
      <input className='me-2 mt-2' name="mobile" onChange={handleChange} value={formData.mobile} placeholder="Mobile no." required />
      <textarea className='me-2 mt-2' name="message" onChange={handleChange} value={formData.message} placeholder="Message" required />
      <button className='buttonsub' type="submit">Submit</button>
    </form>
  );
}

export default ContactForm;
